import axios from '@/axios';

// URL and endpoint constants
const LOGIN_STUDENT_URL = '/students/sign_in';
const LOGIN_TEACHER_URL = '/teachers/sign_in';
const SIGNUP_STUDENT_URL = '/students';
const SIGNUP_TEACHER_URL = '/teachers';
const PASSWORD_URL = '/passwords';


export default {
  // Currently logged in user
  user: {
    authenticated: !!localStorage.getItem('Auth-Token'),
    device: localStorage.getItem('Device-Token'),
    user_type: localStorage.getItem('User-Type'),
    email: localStorage.getItem('Email'),
    name: localStorage.getItem('Name'),
    isStudent: localStorage.getItem('User-Type') === 'student',
  },

  setAuthHeaders(response, userType) {
    localStorage.setItem('Auth-Token', response.data.authentication_token.body);
    localStorage.setItem('Device-Token', response.data.authentication_token.device);
    localStorage.setItem('User-Type', userType);
    localStorage.setItem('Email', response.data[userType].email);
    localStorage.setItem('Name', response.data[userType].first_name);
  },

  // Send a request to the login URL
  logIn(userType, user, err) {
    const url = (userType === 'student') ? LOGIN_STUDENT_URL : LOGIN_TEACHER_URL;
    axios.post(url, user)
      .then((response) => {
        this.setAuthHeaders(response, userType);
        const redirectTo = sessionStorage.getItem('Redirect-after-login');
        if (redirectTo) {
          location.href = redirectTo;
          sessionStorage.removeItem('Redirect-after-login');
        } else {
          location.href = '/user_profile';
        }
      })
      .catch((error) => {
        err(error);
      });
  },

  signUp(userType, user, succ, err) {
    const isStudent = userType === 'student';

    const url = isStudent ? SIGNUP_STUDENT_URL : SIGNUP_TEACHER_URL;
    const data = isStudent ? { student: user } : { teacher: user };

    axios.post(url, data)
      .then((response) => {
        succ();
        this.setAuthHeaders(response, userType);
      })
      .catch((error) => { err(error); });
  },

  // remove the token to log out
  logOut() {
    localStorage.removeItem('Auth-Token');
    localStorage.removeItem('Device-Token');
    localStorage.removeItem('User-Type');
    localStorage.removeItem('Email');
    localStorage.removeItem('Name');
    location.href = '/';
  },

  forgotPassword(url, email, succ, err) {
    axios.post(PASSWORD_URL, { url, email })
      .then(() => { succ(); })
      .catch((error) => { err(error); });
  },
  resetPassword(reset) {
    axios.patch(PASSWORD_URL, { ...reset })
      .then(() => { location.href = '/login'; });
  },
};



// WEBPACK FOOTER //
// ./src/api/v1/auth.js